(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonaveil-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.sv-ig[data-token]');
    roots.forEach(function (root) {
      var token = (root.getAttribute('data-token') || '').trim();
      if (!token) return;
      var count = parseInt(root.getAttribute('data-count') || '5', 10) || 5;
      var live = root.querySelector('[data-live-grid]');
      var manual = root.querySelector('[data-manual-grid]');
      var fields = 'id,caption,media_type,media_url,thumbnail_url,permalink,timestamp';
      var url = 'https://graph.instagram.com/me/media?fields=' + fields + '&limit=' + count + '&access_token=' + encodeURIComponent(token);

      fetch(url)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (json) {
          var items = (json && json.data) || [];
          items = items.filter(function (m) { return m.media_type !== 'VIDEO' || m.thumbnail_url; }).slice(0, count);
          if (!items.length) return;
          var badge = '<svg class="sv-ig__badge" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
          var hover = '<span class="sv-ig__hover"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="17.3" cy="6.7" r="1.1" fill="currentColor"/></svg></span>';
          live.innerHTML = items.map(function (m) {
            var src = m.media_type === 'VIDEO' ? m.thumbnail_url : m.media_url;
            var alt = (m.caption || '').replace(/\s+/g, ' ').slice(0, 120).replace(/"/g, '&quot;');
            return '<li class="sv-ig__tile"><a href="' + m.permalink + '" target="_blank" rel="noopener" aria-label="View post on Instagram">' +
              '<img src="' + src + '" alt="' + alt + '" loading="lazy">' +
              (m.media_type === 'VIDEO' ? badge : '') + hover + '</a></li>';
          }).join('');
          live.hidden = false;
          if (manual) manual.hidden = true;
        })
        .catch(function () { /* keep the manual tiles */ });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
